import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { traderSiteSchema } from './getTraderSites';
import { userSchema } from '../user/getUsers';

export const customerSchema = baseObjectSchema.extend({
  code: z.string().optional(),
  profession: z.string().optional(),
  defaultPaymentTypeId: z.string().optional(),
  defaultPaymentType: z
    .object({
      code: z.string().optional(),
      id: z.string(),
      name: z.string().optional(),
      eType: z.number(),
    })
    .optional(),
  traderId: z.string(),
  trader: z
    .object({
      code: z.string().optional(),
      id: z.string(),
      name: z.string().optional(),
      taxNumber: z.string().optional(),
      job: z.string().optional(),
      address: z.string().optional(),
      zipCode: z.string().optional(),
      title: z.string().optional(),
    })
    .optional(),
});

export const getCustomersWithConditionsSchema = z.array(customerSchema);

export type GetCustomersResponse = z.infer<typeof getCustomersWithConditionsSchema>;

export const getCustomersByIDSchema = baseObjectSchema.extend({
  code: z.string().optional(),
  profession: z.string().optional(),
  defaultPaymentTypeId: z.string(),
  defaultPaymentType: z
    .object({
      code: z.string().optional(),
      id: z.string(),
      name: z.string().optional(),
      eType: z.number(),
    })
    .optional(),
  traderId: z.string(),
  trader: z
    .object({
      code: z.string().optional(),
      id: z.string(),
      name: z.string().optional(),
      taxNumber: z.string().optional(),
      job: z.string().optional(),
      city: z.string().optional(),
      address: z.string().optional(),
      zipCode: z.string().optional(),
    })
    .optional(),
  paymentDays: z.number().optional(),
  discountpercentage: z.number().optional(),
  plafond: z.number().optional(),
  minOrder: z.number().optional(),
  defaultTraderSiteId: z.string().optional(),
  defaultTraderSite: traderSiteSchema.optional(),
  pricingPolicyId: z.string().optional(),
  createUser: userSchema.optional(),
  updateUser: userSchema.optional(),
  defaultDocumentTypeId: z.string().optional(),
  defaultDocumentType: z
    .object({
      id: z.string(),
      isActive: z.boolean(),
      isFromManager: z.boolean(),
      code: z.string(),
      name: z.string(),
    })
    .optional(),
});

export type GetCustomersByIDResponse = z.infer<typeof getCustomersByIDSchema>;
